// import { useEffect, useState } from "react";

import { useMaterialUIController } from "context";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "components/DashboardNavbar";
import DataTable from "components/DataTable";

// Data
import data from "pages/Dashboard/Showrooms/Branches/data";
import useLocale from "context/useLocale";

function ShowroomBranches() {
  const locale = useLocale();
  const { columns, rows, paginationMeta, loadData } = data();
  const [controller] = useMaterialUIController();
  const { currentUser } = controller;
  const entriesPerPage = {
    defaultValue: 15,
    entries: [15, 25, 50, 100, 200],
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {locale("showroomBranchesTable")}
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  canAdd={currentUser.roles.includes("admin")}
                  paginationMeta={paginationMeta}
                  entriesPerPage={entriesPerPage}
                  gotoPage={loadData}
                  showTotalEntries
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ShowroomBranches;
